import { AxiosError } from 'axios';
import { useEffect, useState } from 'react';

import { ErrorHttpResponse, SuccessHttpResponse } from '../../../models/https';
import { CustomerProfile } from '../../../models/risk/risk.model';
import useHttps from '../../useHttps';

const useCustomerProfile = (userId?: string | null) => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const [profile, setProfile] = useState<CustomerProfile | null>(null);

  useEffect(() => {
    if (!userId) return;

    const onSuccess = ({ data }: SuccessHttpResponse<CustomerProfile>) => setProfile(data);
    const onError = (err: AxiosError<ErrorHttpResponse>) => {
      console.error(err?.response?.data?.message ?? 'Failed to load customer profile');
    };

    request(
      { url: `api/v1/admin/risk/customers/${userId}`, method: 'get' },
      onSuccess,
      setLoading,
      onError
    );
    // eslint-disable-next-line
  }, [userId]);

  return { profile, loading };
};

export default useCustomerProfile;
